import React from 'react';
import { Box, TextButton, Text, Button, Loader, StatusIndicator } from '@wix/design-system';
import { UploadExport, Document } from '@wix/wix-ui-icons-common';
const ActionButtons = _ref => {
  let {
    primaryAction,
    secondaryAction
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "18px"
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      width: '141px',
      gap: '5px'
    },
    size: "small",
    prefixIcon: primaryAction.icon,
    onClick: primaryAction.onClick,
    disabled: primaryAction.disabled
  }, primaryAction.label), /*#__PURE__*/React.createElement(TextButton, {
    skin: "standard",
    onClick: secondaryAction.onClick,
    disabled: secondaryAction.disabled
  }, secondaryAction.label));
};
export const IdleState = _ref2 => {
  let {
    onFileUpload,
    onSkipUpload,
    uploadLabel,
    skipLabel,
    formatDescription,
    isCompleted
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true,
    skin: isCompleted ? 'disabled' : undefined
  }, formatDescription), /*#__PURE__*/React.createElement(ActionButtons, {
    primaryAction: {
      label: uploadLabel,
      onClick: onFileUpload,
      icon: /*#__PURE__*/React.createElement(UploadExport, null),
      disabled: isCompleted
    },
    secondaryAction: {
      label: skipLabel,
      onClick: onSkipUpload,
      disabled: isCompleted
    }
  }));
};
export const LoadingState = _ref3 => {
  let {
    uploadedFileName,
    analyzeLabel,
    skipLabel
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "6px",
    padding: "6px",
    border: "1px solid",
    borderColor: "D60",
    borderRadius: "12px"
  }, /*#__PURE__*/React.createElement(Document, null), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, uploadedFileName)), /*#__PURE__*/React.createElement(ActionButtons, {
    primaryAction: {
      label: analyzeLabel,
      icon: /*#__PURE__*/React.createElement(Loader, {
        size: "tiny",
        color: "white"
      }),
      disabled: true
    },
    secondaryAction: {
      label: skipLabel,
      disabled: true
    }
  }));
};
export const ErrorState = _ref4 => {
  let {
    onRetryUpload,
    onSkipUpload,
    retryLabel,
    skipLabel,
    errorMessage
  } = _ref4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    width: "100%",
    gap: "6px"
  }, /*#__PURE__*/React.createElement(StatusIndicator, null), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    skin: "error",
    secondary: true
  }, errorMessage)), /*#__PURE__*/React.createElement(ActionButtons, {
    primaryAction: {
      label: retryLabel,
      onClick: onRetryUpload,
      icon: /*#__PURE__*/React.createElement(UploadExport, null)
    },
    secondaryAction: {
      label: skipLabel,
      onClick: onSkipUpload
    }
  }));
};
//# sourceMappingURL=UploadState.js.map